import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import {Badge} from "primereact/badge";

const PayrollListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity} = useParams();
  const [payrolls, setPayrolls] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams);
      apiCall('get', '/api/v2/payroll' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setPayrolls(response.data.data.items);
        })
        .catch(error => {
          try {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          } catch (e) {
            console.error('Toast error:', e);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }, Math.random() * 1000 + 250);
  };

  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  };
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  };
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  };
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
          {options.first} - {options.last} / {options.totalRecords}
        </span>
      );
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const actionBodyTemplate = (rowData) => {
    const roles = (localStorage.getItem('roles') || '').toString();
    const isClosed = !!rowData.closed;

    return (
      <React.Fragment>
        <Button  
          icon="pi pi-eye"
          className="p-button p-mr-2"
          tooltip={t('view')}
          tooltipOptions={{ position: 'left' }}
          onClick={() => {
            if (entity === 'payroll') {
              history.push('/hr/' + props.entity + '/read/' + rowData.id + history.location.search);
            }
          }}/>
        {roles.includes('role_payroll_write') &&
          <Button
            icon="pi pi-pencil"
            className="p-button-warning p-mr-2"
            tooltip={t('edit')}
            tooltipOptions={{position: 'left'}}
            disabled={isClosed}
            onClick={() => {
              if (entity === 'payroll') {
                history.push('/hr/payroll/update/' + rowData.id);
              }
            }}
          />
        }
        {/* {roles.includes('role_') &&
          <Button
            icon="pi pi-trash"
            className="p-button-danger"
            tooltip={t('delete')}
            tooltipOptions={{position: 'left'}}
            disabled={isClosed}
            onClick={() => {
              if (window.confirm('A törlés megerősítésére van szükség!')) {
                setLoading(true);
                apiCall('delete', '/api/v2/payroll/' + rowData.id)
                  .then(response => {
                    window.App.toastShow('success', 'Sikeres törlés!');
                    window.App.setState({rerenderPayrollList: Math.random()});
                  })
                  .catch(error => {
                    try {
                      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                    } catch (e) {
                      console.error('Toast error:', e);
                    }
                  })
                  .finally(() => {
                    setLoading(false);
                  });
              }
            }}
          />
        } */}
      </React.Fragment>
    );
  };

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderPayrollList]);

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={payrolls} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column
          field="company.name"
          bodyClassName="col-body-font-bold"
          header={t('columnCompany')}
          sortable
          filter
          body={(rowData) => rowData.company?.name || ''}
        />

        <Column field="closed" header={t('columnStatus')} body={(rowData) => {
          return <Badge value={rowData.closed ? 'Lezárt' : 'Nyitott'} 
                        severity={rowData.closed ? 'success' : 'warning'} />;
        }}></Column>

        <Column field="date_from" header={t('columnPeriodStart')} sortable body={(rowData) => {
          if (!rowData.date_from) return '';
          return <>{window.App.formatDateValue(rowData.date_from)}</>;
        }}/>
        <Column field="date_until" header={t('columnPeriodEnd')} sortable body={(rowData) => {
          if (!rowData.date_until) return '';
          return <>{window.App.formatDateValue(rowData.date_until)}</>;
        }}/>
        <Column field="currency" header={t('columnCurrency')} sortable filter></Column>
        {/* <Column field="notes" header={t('columnComment')} sortable filter></Column> */}
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  );
};

export default withTranslation('common')(PayrollListComponent);
